// src/components/CookieConsent/CookieConsentBannerComponent.js
import React, { useState } from 'react';
import { useCookieConsent } from './CookieConsentContext';

const CookieConsentBannerComponent = () => {
    const { consentState, handleSaveConsent } = useCookieConsent();
    const [showPreferences, setShowPreferences] = useState(false);

    // Lokalny stan dla checkboxów w panelu preferencji
    const [localConsent, setLocalConsent] = useState(consentState);

    const handleAcceptAll = () => {
        handleSaveConsent({ necessary: true, analytics: true, marketing: true });
    };

    const handleRejectAll = () => {
        handleSaveConsent({ necessary: true, analytics: false, marketing: false });
    };

    const handleTogglePreferences = () => {
        setShowPreferences(!showPreferences);
        setLocalConsent(consentState); 
    };

    const handlePreferenceChange = (e) => {
        const { name, checked } = e.target;
        setLocalConsent(prev => ({ ...prev, [name]: checked }));
    };

    const handleSavePreferences = () => {
        handleSaveConsent(localConsent);
    };

    // ZMIANA: Bardzo małe paddingi (px-2 py-1.5) i bardzo mały tekst (text-[10px] lub text-xs)
    // dodano flex-1, żeby przyciski dzieliły miejsce po równo
    const buttonBaseStyles = "flex-1 md:flex-none justify-center rounded px-2 py-1.5 text-[10px] sm:text-xs font-semibold transition-colors focus:outline-none border border-transparent whitespace-nowrap";

    return (
        // ZMIANA: Mniejszy padding zewnętrzny (p-2) żeby nie marnować miejsca przy krawędziach
        <div className="fixed bottom-0 left-0 right-0 z-[9999] p-2 md:p-4">
            <div className="max-w-4xl mx-auto bg-gray-800/95 backdrop-blur-md text-white rounded-lg shadow-2xl border border-gray-700 overflow-hidden">
                {!showPreferences ? (
                    // ====================== WIDOK GŁÓWNY ======================
                    <div className="p-3">
                        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                            <div className="flex-grow text-center md:text-left">
                                <h3 className="font-bold text-sm">Cenimy Twoją prywatność</h3>
                                <p className="text-xs text-gray-300 mt-1">
                                    Używamy plików cookie, aby ulepszyć Twoje doświadczenia. Wybierz, na co się zgadzasz. Więcej informacji znajdziesz w naszej {' '}
                                    {/* ZMIANA LINKU */}
                                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="font-semibold text-blue-400 hover:text-blue-300 hover:underline">Polityce Prywatności</a>.
                                </p>
                            </div>

                            {/* Sekcja Przycisków - JEDNA LINIA (flex-row) */}
                            <div className="flex flex-row items-center gap-2 w-full md:w-auto justify-between md:justify-end pt-1 md:pt-0 border-t border-gray-700/50 md:border-0">
                                {/* Odrzuć */}
                                <button
                                    onClick={handleRejectAll}
                                    className={`${buttonBaseStyles} bg-gray-700 hover:bg-gray-600 text-gray-300`}
                                >
                                    Odrzuć
                                </button>

                                {/* Dostosuj */}
                                <button
                                    onClick={handleTogglePreferences}
                                    className={`${buttonBaseStyles} bg-gray-700 hover:bg-gray-600 text-gray-300`}
                                >
                                    Dostosuj
                                </button>
                                
                                {/* Akceptuj - Wyróżniony */}
                                <button
                                    onClick={handleAcceptAll}
                                    className={`${buttonBaseStyles} bg-green-700 hover:bg-green-600 text-white shadow-sm`}
                                >
                                    Akceptuję
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    // ====================== WIDOK PREFERENCJI ======================
                    <div className="p-4 md:p-6 max-h-[80vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-3 border-b border-gray-700 pb-2">
                            <h3 className="font-bold text-sm md:text-base">Ustawienia plików cookie</h3>
                            <button onClick={handleTogglePreferences} className="text-gray-400 hover:text-white">✕</button>
                        </div>

                        <div className="space-y-2">
                            {/* Checkboxy - mniejsze paddingi */}
                            <label className="flex items-center p-2 bg-gray-900/50 rounded border border-gray-700 opacity-60">
                                <input type="checkbox" checked disabled className="rounded bg-gray-600 border-none text-blue-500 mr-3" />
                                <div>
                                    <span className="text-xs font-bold block">Niezbędne</span>
                                    <span className="text-[10px] text-gray-400">Wymagane do działania.</span>
                                </div>
                            </label>

                            <label className="flex items-center p-2 bg-gray-900/50 rounded border border-gray-700 cursor-pointer">
                                <input type="checkbox" name="analytics" checked={localConsent.analytics} onChange={handlePreferenceChange} className="rounded bg-gray-700 border-gray-500 text-blue-500 mr-3 focus:ring-0" />
                                <div>
                                    <span className="text-xs font-bold block">Analityczne</span>
                                    <span className="text-[10px] text-gray-400">Statystyki użycia.</span>
                                </div>
                            </label>

                            <label className="flex items-center p-2 bg-gray-900/50 rounded border border-gray-700 cursor-pointer">
                                <input type="checkbox" name="marketing" checked={localConsent.marketing} onChange={handlePreferenceChange} className="rounded bg-gray-700 border-gray-500 text-blue-500 mr-3 focus:ring-0" />
                                <div>
                                    <span className="text-xs font-bold block">Marketingowe</span>
                                    <span className="text-[10px] text-gray-400">Reklamy (Pixel).</span>
                                </div>
                            </label>
                        </div>

                        <div className="mt-4 flex justify-end gap-2">
                            <button
                                onClick={handleRejectAll}
                                className={`${buttonBaseStyles} flex-none bg-gray-700 hover:bg-gray-600`}
                            >
                                Odrzuć
                            </button>
                            <button
                                onClick={handleSavePreferences}
                                className={`${buttonBaseStyles} flex-none bg-blue-600 hover:bg-blue-500`}
                            >
                                Zapisz
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CookieConsentBannerComponent;